<template>
  <el-header class="header">
    <lang-switcher />
    <p class="header__title">
      {{headerTitle}}
      <span class="header__title-count">
        {{headerMeta.subtitle}} {{headerCount}}
      </span>
    </p>
    <template v-if="headerMeta.action.forAdmin && isAdmin || !headerMeta.action.isAdmin">
      <el-button
        v-if="headerMeta.action.display"
        size="medium"
        type="primary"
        class="header__button"
        @click="() => headerMeta.action.method(this)"
      >
        {{headerMeta.action.title}}
      </el-button>

      <el-drawer
        :visible.sync="drawer"
        :direction="direction"
        size="100%"
        :append-to-body="true"
        :custom-class="headerMeta.action.customClass"
      >
        <component :is="headerMeta.action.template"></component>
      </el-drawer>
    </template>
  </el-header>
</template>

<script>
/*
  from the config ../config/header
  - title
  - subtitle
  - action
  - templates
  - custom-class

  To change or add, you need to perform actions in the config
*/

// vuex
import {mapGetters} from "vuex";

// config
import header from "../config/header";

// templates for headerMeta config
import AddUser from './templates/AddUser';
import CreateFeed from './templates/CreateFeed';

// bus
import { drawerBus } from '../bus/drawer';

// components
import LangSwitcher from '../components/langSwitcher/LangSwitcher';

export default {
  name: 'AppHeader',
  data() {
    return {
      drawer: false,
      direction: 'rtl',
    };
  },
  computed: {
    ...mapGetters([
      "userRole",
      "isAdmin",
    ]),
    headerMeta() {
      return  header.find(item => item.name === this.$route.name);
    },
    headerTitle() {
      const result = this.headerMeta.title.static
        ?
          this.headerMeta.title.data
        :
          this.$store.getters[this.headerMeta.title.getter](this.$route.params.threadId)
            ?
              this.$store.getters[this.headerMeta.title.getter](this.$route.params.threadId)
            :
              this.headerMeta.title.default;
      document.title = result;
      return result;
    },
    headerCount() {
      return this.headerMeta.count.display ? this.$store.getters[this.headerMeta.count.getter] : "";
    }
  },
  created() {
    drawerBus.$on('toggleDrawer', () => {
      this.drawer = !this.drawer;
    })
  },
  components: {
    AddUser,
    CreateFeed,
    LangSwitcher,
  }
}
</script>

<style>
  @import "../style/header.css";
</style>
